import { faqs } from '@/mocks/site';
import FaqAccordion from '@/components/feature/FaqAccordion';
import Reveal from '@/components/base/Reveal';

export default function FaqSection() {
  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-5 lg:gap-14">
        <Reveal className="lg:col-span-2">
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">常见问题</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于黑料大赛，你可能想知道
          </h2>
          <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
            收录标准、榜单算法、投稿方式，这里一次讲清楚。如果还有没覆盖到的问题，邮件问我们就好。
          </p>
          <div className="mt-6 h-52 w-full overflow-hidden rounded-lg border border-background-200 md:h-64">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20desk%20flatlay%20abstract%2C%20stacked%20paper%20sheets%20and%20index%20cards%2C%20deep%20crimson%20ribbon%20and%20antique%20gold%20accents%2C%20soft%20window%20light%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20aesthetic%2C%20high%20detail&width=900&height=700&seq=faq-side-01&orientation=landscape"
              alt="黑料大赛常见问题与收录标准"
              title="黑料大赛 - 常见问题"
              className="h-full w-full object-top"
            />
          </div>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-3">
          <FaqAccordion items={faqs.slice(0, 5)} />
        </Reveal>
      </div>
    </section>
  );
}